module.exports = __webpack_public_path__ + "static/img/header_2880.fa62e26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/dashboard/header_2880.png
// module id = Zeqd
// module chunks = 2